<template>
  <div class="content2 contentPage swiper-slide" :class="nowPage === 1 ? 'cartoon' : ''">
    <img :src="qianYanImg" class="qianYanImg">
    <div class="qianYanTxt overflow">
      <p class="cn">鸟类是天空中的绝对统治者，它们的现生种类已超过一万种。当我们抬头看着鸟儿们自由翱翔时，是否也会好奇这些空中精灵究竟是在何时、又是如何出现的？</p>
      <p class="cn">地球诞生至今已经超过46亿年，在这漫长的演化历史进程中，形形色色的物种不断出现又消失。距今两亿多年到六千五百万年前的中生代是爬行动物的时代，恐龙以势不可挡的气势全面称霸了陆地生态系统的最顶层，海洋和天空则分别被海生爬行动物和翼龙类所统治。白垩纪早期出现了最原始的鸟类，如我国东北地区发现的早期鸟类。那么鸟类和恐龙究竟有什么关系，它们又是如何长出羽毛的？这些答案就藏于远古化石和现代鸟类之中。</p>
      <p class="cn">为了向广大观众普及古生物学和现代生物学知识，了解生命进化历程中波澜壮阔的故事，同时珍惜和保护现今的化石和动植物资源，在凌源洪涛古化石博物馆、恐龙园文化旅游集团股份有限公司、卓谨信息科技有限公司的大力支持下和辽宁古生物博物馆，常州博物馆经过精心筹备于暑期推出《腾飞之龙——从龙到鸟的演化之旅》。现在就让我们通过丰富多彩的古生物化石和形态各异的现代鸟类，来一睹远古生命与现代动物碰撞出的精彩火花吧！</p>
      <div class="heng"></div>
      <p class="en">Birds have dominated the sky for millions of years, with more than 10,000 living species now. When we look up at the flying birds, will we want to know when and how did they emerged and evolved?</p>
      <p class="en">It has been for 4.6 billion years since the birth of our planet. During the long life evolution period, all kinds of species have been emerged, but many kinds of species disappeared at the same time. Mesozoic is the Reptile Era during 200 million years to 65 million years ago. The dinosaurs dominated the top layer of the terrestrial ecosystem with overwhelming force in the Mesozoic era, while the marine reptiles and pterosaurs ruled the ocean and sky respectively. The most primitive birds appeared in the Cretaceous period from northeast China. So what exactly is the relationship between birds and dinosaurs, and how did they get their feathers? All the answers lie in the fossils and modern birds.</p>
      <p class="en">In order to popularize the knowledge of paleontology and modern biology, realize the magnificent story of the life evolution, then cherish and protect the fossil, animals and plants resources we owned today, with the support of Hongtao Fossil Museum of Lingyuan, Dinosaur Land Culture & Tourism Group Co. Ltd, Zhuo Jin Information Technology Co. Ltd and Paleontological Museum of Liaoning Province. Changzhou museum hold the exhibition of “The Flying Dinosaurs——The Evolution from Dinosaur to Bird” during summer vacation. Now let’s appreciate the most splendid sparks of ancient life and modern animals through the various fossils and colorful birds.</p>
    </div>
  </div>
</template>

<script>
import qianYanImg from '@/assets/img/content2/qianYan.png'

export default {
  data () {
    return {
      qianYanImg, // 前言
    }
  },

  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './content2.styl'
</style>